'use client';

// @ts-ignore
import presetReact from '@bbob/preset-react/lib';
import { FC } from 'react';
import { BBNode, ParseBBCodeProps } from 'atoms/ParseBBCode/types';
// @ts-ignore

/**  !!!!!! copy from npm package - node_modules/@bbob/react/es/.
 * Remove defaultProps error.*/
import BBCode from './bbob-react-lib';
import { decodeHTML } from './decodeHTML';
import styles from './styles.module.css';

const additionalTags = {
  quote: (node: BBNode) => ({
    tag: 'blockquote',
    content: node.content,
  }),
  b: (node: BBNode) => ({
    tag: 'strong',
    content: node.content,
  }),
  b1: (node: BBNode) => ({
    tag: 'span',
    attrs: { className: styles.h1 },
    content: node.content,
  }),
  b2: (node: BBNode) => ({
    tag: 'span',
    attrs: { className: styles.h2 },
    content: node.content,
  }),
  n: (node: BBNode) => ({
    tag: 'br',
    content: node.content,
  }),
  s: () => ({
    tag: 'span',
    attrs: { style: { whiteSpace: 'pre' } },
    content: '\u00A0',
  }),
  shy: () => ({
    tag: 'span',
    content: '\u00AD',
  }),
  nbhy: () => ({
    tag: 'span',
    content: '\u2011',
  }),
  heart: () => ({
    tag: 'span',
    content: '&hearts;',
  }),
  i: (node: BBNode) => ({
    tag: 'em',
    content: node.content,
  }),
  u: (node: BBNode) => ({
    tag: 'u',
    content: node.content,
  }),
  color: (node: BBNode) => ({
    tag: 'span',
    attrs: { style: { color: node.attrs?.color } },
    content: node.content,
  }),
  h2: (node: BBNode) => ({
    tag: 'h2',
    content: node.content,
  }),
  h3: (node: BBNode) => ({
    tag: 'h3',
    content: node.content,
  }),
  ul: (node: BBNode) => ({
    tag: 'ul',
    content: node.content,
  }),
  li: (node: BBNode) => ({
    tag: 'li',
    content: node.content,
  }),
  'text-indent': (node: BBNode) => ({
    tag: 'p',
    attrs: { style: { textIndent: `${node.attrs?.size}em` } },
    content: node.content,
  }),
  fieldset: (node: BBNode) => ({
    tag: 'fieldset',
    content: [
      { tag: 'legend', content: node.attrs?.title },
      { tag: 'span', content: node.content },
    ],
  }),
  img: (node: BBNode) => ({
    tag: 'img',
    attrs: { src: node.content },
  }),
  material: (node: BBNode) => ({
    tag: 'a',
    attrs: { href: `/products/${node.attrs?.productid}` },
    content: 'Product Link',
  }),
  blog: (node: BBNode) => ({
    tag: 'a',
    attrs: { href: `/blog/${node.attrs?.slug}` },
    content: 'Blog Link',
  }),
  url: (node: BBNode) => {
    const href = node.attrs ? Object.values(node.attrs) : '';
    return {
      tag: 'a',
      attrs: {
        className: styles.link,
        href,
        target: '_blank',
      },
      content: node.content,
    };
  },
  'url-intern': (node: BBNode) => ({
    tag: 'a',
    attrs: { href: node.attrs?.destination },
    content: node.content,
  }),
  email: (node: BBNode) => ({
    tag: 'a',
    attrs: { href: `mailto:${node.attrs?.receiver}` },
    content: 'Email Link',
  }),
  layer: (node: BBNode) => ({
    tag: 'a',
    attrs: { href: node.attrs?.destination },
    content: 'EIS Overlay Link',
  }),
  marken: (node: BBNode) => ({
    tag: 'a',
    attrs: { href: `/products/${node.attrs?.productid}` },
    content: 'Marken Product Link',
  }),
  product: (node: BBNode) => ({
    tag: 'a',
    attrs: {
      href: node.attrs ? ['absolute product url'] : '',
      'data-overlay': node.attrs?.overlay === 'true' ? true : undefined,
    },
    content: 'Product Link',
  }),
};

const preset = presetReact.extend((tags: BBNode) => {
  return {
    ...tags,
    ...additionalTags,
  };
});

export const ParseBBCode: FC<ParseBBCodeProps> = ({ content }) => {
  return (
    <BBCode
      plugins={[preset()] as never}
      options={{
        onlyAllowTags: [
          /** default START */
          'b',
          'i',
          'u',
          's',
          'url',
          'img',
          'quote',
          'code',
          'style',
          'list',
          'color',
          /** default END */
          ...Object.keys(additionalTags),
        ],
      }}
    >
      {decodeHTML(content)}
    </BBCode>
  );
};
